import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Convert an axios error into a safe human-readable string.
 * Handles the structured 402 `detail` object introduced by subscription
 * enforcement (see /app/backend/server.py::_enforce_feature_access). Returns
 * `null` when the error is already being handled globally (e.g. USAGE_LIMIT_REACHED
 * → UpgradeModal). Callers should suppress their toast when this returns null.
 */
export function humanizeApiError(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object") {
    // Handled by the global UpgradeModal via the axios interceptor
    if (d.code === "USAGE_LIMIT_REACHED" || d.code === "SUBSCRIPTION_EXPIRED") return null;
    return d.message || d.detail || fallback;
  }
  if (typeof d === "string" && d) return d;
  if (typeof err?.message === "string" && err.message) return err.message;
  return fallback;
}

/**
 * Toast an axios error safely. No-ops when the error is already handled by
 * the global UpgradeModal (avoids rendering an object as a React child and
 * from double-notifying the user).
 */
import { toast as _apiToast } from "sonner";
export function apiErrorToast(err, fallback) {
  const msg = humanizeApiError(err, fallback);
  if (msg) _apiToast.error(msg);
}

